import baseStore from '../generic_store';
import Axios from "axios";

const base = baseStore('contacts');

const state = {
    ...base.state,
    base_url: '/api/contacts',
    resourceName: 'Contact',
    model: {},
};

const getters = {
    ...base.getters,
};

const actions = {
    ...base.actions,
    export({state, commit}) {
        Axios.get(`${state.base_url}/export`, { responseType: "blob" })
            .then( (response) => {
                const blob = new Blob([response.data], { type: "text/csv" });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = 'export-contacts';
                link.click();
                URL.revokeObjectURL(link.href);
            })
            .catch( (errors) => {
                console.warn(errors);
                if (errors.response && errors.response.status === 422) {
                    commit('SET_ERRORS', errors.response.data.errors);
                }
            })
            .finally( () => {

            })
    }
};

const mutations = {
    ...base.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

